// extracted by mini-css-extract-plugin
export default {"superViewDetailsFooterContainer":"rKGtVL","superViewDetailsFooterHeading":"lvr8RU","superViewDetailsFooterCTA":"cpkOuf","superViewDetailsFooterCTAArrow":"N1QqCT"};